<template>
  <div class="hero">
    <div
      class="hero--content"
      :style="`background-image:url(${heroBackground})`"
    ></div>
  </div>
</template>

<script>
export default {
  name: "Hero",
  props: {
    msg: String
  },
  data() {
    return {
      heroBackground: "/img/hero1.jpg"
    };
  },
  methods: {
    createObserver() {
      var el = this.$el;
      // console.log('root > ', root);
      var options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.2
      };

      if (window.IntersectionObserver) {
        this.observer = new IntersectionObserver(this.handleIntersect, options);
        this.observer.observe(el);
      }
    },
    handleIntersect(entries) {
      let vm = this;
      entries.forEach(function(entry) {
        if (entry.intersectionRatio > vm.prevRatio) {
          vm.mode = "top";
        } else {
          vm.mode = "scrolled";
        }
        vm.prevRatio = entry.intersectionRatio;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.hero
  width 100%
  height 85vh
  &--content
    width 100%
    height 85vh
    background-repeat no-repeat
    background-size cover
    background-position 50% 50%
    background-attachment fixed
</style>
